import React from "react";
import styled from "styled-components";
import { Row, Col, Empty, Button, Spin, Radio } from "antd";
import {
  StyledTitle,
  TitleContainer,
} from "components/job/index/jobInformationRow";
import IssueList from "./issue/issueList";
import NewIssueModal from "./modal/newIssueModal";

const IssueRow = (props) => {
  // Props
  const { data, status } = props;

  // Component state
  const [jobIssue, setJobIssue] = React.useState([]);
  const [openNewIssueModal, setOpenNewIssueModal] = React.useState(false);
  const [currentIssueTab, setCurrentIssueTab] = React.useState("unresolved");

  const unresolvedIssueCount = data?.issues?.filter((issue) => !issue.resolved)
    .length;
  const resolvedIssueCount = data?.issues?.filter((issue) => issue.resolved)
    .length;

  React.useEffect(() => {
    setJobIssue(data?.issues);
    setCurrentIssueTab("all");
  }, [data]);

  // Component function
  const handleIssueFilter = (filter) => {
    setCurrentIssueTab(filter);
    if (filter === "unresolved") {
      const unresolvedIssue = data?.issues?.filter((issue) => !issue.resolved);
      setJobIssue(unresolvedIssue);
    } else if (filter === "resolved") {
      const resolvedIssue = data?.issues?.filter((issue) => issue.resolved);
      setJobIssue(resolvedIssue);
    } else {
      const allIssue = data?.issues;
      setJobIssue(allIssue);
    }
  };

  return (
    <StyledContainer>
      <Row gutter={8}>
        <Col xs={24} style={{ paddingLeft: "2px" }}>
          <StyledBox>
            <TitleContainer>
              <StyledTitle>Issues</StyledTitle>
            </TitleContainer>
            {status === "loading" || status === "idle" ? (
              <SpinContainer>
                <Spin />
              </SpinContainer>
            ) : (
              <>
                {data?.issues?.length > 0 ? (
                  <>
                    <StyledIssueRadio>
                      <Radio.Group
                        defaultValue="unresolved"
                        size="medium"
                        value={currentIssueTab}
                        onChange={(e) => handleIssueFilter(e.target.value)}
                      >
                        <Radio.Button value="unresolved">
                          Unresolved ({unresolvedIssueCount})
                        </Radio.Button>
                        <Radio.Button value="resolved">
                          Resolved ({resolvedIssueCount})
                        </Radio.Button>
                        <Radio.Button value="all">
                          All ({data?.issues?.length})
                        </Radio.Button>
                      </Radio.Group>
                    </StyledIssueRadio>
                    <IssueList
                      issues={jobIssue}
                      status={status}
                      setOpenNewIssueModal={setOpenNewIssueModal}
                      jobId={data?.id}
                    />
                  </>
                ) : (
                  <EmptyContainer>
                    <Empty
                      image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
                      imageStyle={{
                        height: 60,
                      }}
                      description={<span>No issue created yet</span>}
                      style={{ marginBottom: "20px" }}
                    >
                      <Button
                        type="primary"
                        onClick={() => setOpenNewIssueModal(true)}
                      >
                        Create new issue
                      </Button>
                    </Empty>
                  </EmptyContainer>
                )}
              </>
            )}
          </StyledBox>
        </Col>
      </Row>

      <NewIssueModal
        visible={openNewIssueModal}
        onCancel={() => setOpenNewIssueModal(false)}
        title="Report an issue"
        issueFor="Job"
        jobId={data?.id}
      />
    </StyledContainer>
  );
};

const StyledBox = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.grey[400]};
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const EmptyContainer = styled.div`
  display: flex;
  height: 90%;
  align-items: center;
  justify-content: center;
  margin-bottom: ${(props) => props.theme.spacing[4]};
`;

const SpinContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  height: 90%;
`;

const StyledContainer = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[2]};
`;

const StyledIssueRadio = styled.div`
  padding: ${(props) => props.theme.spacing[2]};
  padding-bottom: 0;
`;

export default IssueRow;
